export default __webpack_public_path__ + "static/media/prev.6bce91a7.svg";